<si-login-page
[heading]="'APP.NAME' | translate" [subtitle]="'APP.CLAIM' | translate" [links]="[
'HORIZON_UI.ABOUT_PAGE.LINKS_ABOUT.CORPORATE_LINK',
'HORIZON_UI.ABOUT_PAGE.LINKS_ABOUT.PRIVACY_NOTICE',
'HORIZON_UI.ABOUT_PAGE.LINKS_ABOUT.ACCEPTABLE_USE_POLICY'
]" [availableLanguages]="['en', 'de', 'fr']">
<si-virtual-assistant-button />
</si-login-page>
